import React, { Component } from 'react';

class Home extends Component {
  state = {};
  render() {
    return (
      <div className="page-container">
        <div className="page-header">Home</div>
      </div>
    );
  }
}

export default Home;
